const emailTemplates = {
  infoBannerTitle: "Email templates are managed in Supabase Auth",
  infoBannerDesc: "Changes made there will immediately affect all system emails.",
  openInSupabase: "Open Email Templates in Supabase",
  authEmailsTitle: "Authentication Emails",
  confirmSignUp: "Confirm Sign Up",
  confirmSignUpDesc: "Sent after account creation to verify email address.",
  inviteUser: "Invite User",
  inviteUserDesc: "Invitation sent when a user is invited to join the system.",
  magicLink: "Magic Link",
  magicLinkDesc: "Passwordless login email with a single-use login link.",
  changeEmail: "Change Email Address",
  changeEmailDesc: "Verification sent when a user updates their email.",
  resetPassword: "Reset Password",
  resetPasswordDesc: "Sent after clicking 'Forgot password'.",
  reauthentication: "Reauthentication",
  reauthenticationDesc: "Verification required before performing sensitive actions.",
  securityEmailsTitle: "Security Emails",
  passwordChanged: "Password Changed",
  passwordChangedDesc: "Notification sent when the password is changed.",
  emailChanged: "Email Address Changed",
  emailChangedDesc: "Notification sent when the email address changes.",
  phoneChanged: "Phone Number Changed",
  phoneChangedDesc: "Notification sent when the phone number changes.",
  identityLinked: "Identity Linked",
  identityLinkedDesc: "Notification when a login provider is connected (Google / OAuth).",
  identityUnlinked: "Identity Unlinked",
  identityUnlinkedDesc: "Notification when a login provider is removed.",
  mfaAdded: "MFA Method Added",
  mfaAddedDesc: "Notification when multi-factor authentication is enabled.",
  mfaRemoved: "MFA Method Removed",
  mfaRemovedDesc: "Notification when multi-factor authentication is disabled.",
  variablesTitle: "Dynamic Variables",
  varConfirmationUrl: "Confirmation/action link",
  varSiteUrl: "Site URL",
  varEmail: "User email address",
  customizationTitle: "Customization Options",
  customSubject: "Email subject line",
  customHtml: "HTML body and text content",
  customLayout: "Responsive layout and design",
  customCta: "Call-to-action button",
  customRtl: "RTL compatibility",
  customBrand: "Company logo and brand colors",
} as const;
export default emailTemplates;
